import { ETourId, type ITourConfig } from '../types';

/**
 * Tour shown on the integrations list (Explore Integrations) page.
 *
 * Three steps:
 * 1. Browse integrations — the full integrations grid
 * 2. Integration cards — a single integration card
 * 3. Manage connected integrations — the Connections tab
 */
export const integrationsListTour: ITourConfig = {
  id: ETourId.INTEGRATIONS_LIST,
  // In new flow, do not trigger this tour. Disabling it for now.
  enabled: false,
  steps: [
    {
      id: 'integrations-grid',
      target: '[data-tour-id="integrations-grid"]',
      titleKey: 'tours.integrationsList.grid.title',
      descriptionKey: 'tours.integrationsList.grid.description',
      position: 'topLeft',
    },
    {
      id: 'integrations-first-card',
      target: '[data-tour-id="integrations-grid"] > a:first-child',
      titleKey: 'tours.integrationsList.card.title',
      descriptionKey: 'tours.integrationsList.card.description',
      position: 'rightTop',
    },
    {
      id: 'integrations-connections-tab',
      target: '[data-tour-id="integrations-connections-tab"]',
      titleKey: 'tours.integrationsList.connectionsTab.title',
      descriptionKey: 'tours.integrationsList.connectionsTab.description',
      finishLabelKey: 'tours.integrationsList.connectionsTab.finishLabel',
      position: 'leftTop',
    },
  ],
  namespace: 'tours',
  variant: 'default',
  size: 'sm',
  analytics: {
    enabled: true,
    eventPrefix: 'tour_integrations_list',
    metadata: {
      tourName: 'Integrations List',
    },
  },
  persistence: {
    strategy: 'localStorage',
  },
};
